import { useEffect, useRef } from 'react';
import { UrlToSearchBar } from './searchRegex';
export const toggleSearchOnScroll = (isMobile, updateEshopState) => {
    let canScrollEventTimer = null;
    if (typeof window !== 'undefined' && isMobile) {
        let previousPosY = window.scrollY;
        let canScrollEvent = true;
        let visible = true;
        const handleScroll = () => {
            // Condition to prevent the scroll event for performances (it triggers every 50ms)
            if (canScrollEvent) {
                const newPosY = window.scrollY;
                canScrollEvent = false;
                // We check if the user scroll down
                if (newPosY > previousPosY + 40) {
                    if (visible) {
                        updateEshopState({ type: 'setIsVisibleSearch', payload: false });
                        visible = false;
                    }
                }
                // We check if the user scroll up
                else if (newPosY < previousPosY - 40) {
                    if (!visible) {
                        updateEshopState({ type: 'setIsVisibleSearch', payload: true });
                        visible = true;
                    }
                }
                previousPosY = newPosY;
                // Timeout to allow the trigger of the scroll event every 50ms
                canScrollEventTimer = setTimeout(() => {
                    canScrollEvent = true;
                }, 50);
            }
        };
        window.addEventListener('scroll', handleScroll);
        return () => {
            if (canScrollEventTimer) {
                clearTimeout(canScrollEventTimer);
            }
            window.removeEventListener('scroll', handleScroll);
        };
    }
    // return canScrollEventTimer;
    return () => {
        if (canScrollEventTimer) {
            clearTimeout(canScrollEventTimer);
        }
    };
};
export const updateSearchFieldFromUrl = (updateEshopState, searchText, windowObj = typeof window !== 'undefined' ? window : undefined) => {
    if (windowObj) {
        const pathArray = windowObj.location.pathname.split('/');
        const findKw = pathArray.find((item) => item === 'kw');
        if (findKw && !searchText) {
            const searchTextFromUrl = decodeURI(pathArray[pathArray.length - 1]);
            updateEshopState({ type: 'setSearchText', payload: UrlToSearchBar(searchTextFromUrl) });
        }
    }
};
export const bannerResizeControl = (updateEshopState, mobileBreakpoint) => {
    if (typeof window !== 'undefined') {
        const handleResize = () => {
            const isMobile = window.innerWidth < mobileBreakpoint;
            updateEshopState({ type: 'setIsMobile', payload: isMobile });
        };
        handleResize();
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }
};
export const stickyControl = (updateEshopState, refContainerInfoParent, refContainer) => {
    if (typeof window !== 'undefined') {
        let isStickyVar = false;
        const elmContainer = document.querySelector('#eshopHeaderContainerInfo');
        if (refContainerInfoParent.current && elmContainer && elmContainer.clientHeight > 0) {
            refContainerInfoParent.current.style.height = elmContainer.clientHeight + 'px';
        }
        const callbackFn = () => {
            if (refContainerInfoParent && refContainerInfoParent.current && refContainer && refContainer.current) {
                // If the user scroll below the eshop header (without the banner), isVisible become false,
                // and we show only the eshop header (without the banner) with the sticky property.
                // If the user scroll above the previous place of the eshop header (without the banner),
                // isVisible become true, and we show the entire eshop header.
                const rect = refContainerInfoParent.current.getBoundingClientRect();
                const isVisible = rect.top >= 0;
                if (!isVisible && !isStickyVar) {
                    updateEshopState({ type: 'setIsSticky', payload: true });
                    isStickyVar = true;
                }
                else if (isVisible && isStickyVar) {
                    updateEshopState({ type: 'setIsSticky', payload: false });
                    isStickyVar = false;
                }
            }
            else if (!isStickyVar) {
                updateEshopState({ type: 'setIsSticky', payload: true });
                isStickyVar = true;
            }
        };
        window.addEventListener('scroll', callbackFn);
        return () => window.removeEventListener('scroll', callbackFn);
    }
};
export const useToggleEshopHeader = (eshopState, updateEshopState) => {
    const controlDisplayFromEventState = useRef(eshopState.controlDisplayFromEvent);
    const handleDisplayEshopHeader = () => {
        controlDisplayFromEventState.current = !controlDisplayFromEventState.current;
        updateEshopState({ type: 'setControlDisplayFromEvent', payload: controlDisplayFromEventState.current });
    };
    useEffect(() => {
        if (typeof window !== 'undefined') {
            document.addEventListener('CONTROL_ESHOP_HEADER_DISPLAY_FROM_EVENT', handleDisplayEshopHeader);
            return () => {
                document.removeEventListener('CONTROL_ESHOP_HEADER_DISPLAY_FROM_EVENT', handleDisplayEshopHeader);
            };
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return controlDisplayFromEventState;
};
